export default __webpack_public_path__ + "static/media/donate.3b0db012.png";